import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service";

// Card payments (Moneris Checkout), through members-api-gateway /card-payments -> portal-proxy ->
// drawbridge-payment-service (#4647). The service decides; the widget's callbacks only tell us when to ask.
const url = (path = "") =>
  `${SettingsService.settings.APIURL}card-payments${path}`;

const state = {
  payments: [],
};

const getters = {
  payments: (state) => state.payments,
};

// the service answers errors with a JSON body (problem details, or the payment for a refused start)
const body = (error) => error?.response?.data;

const actions = {
  // { payment, ticket, mode, scriptUrl }; a refused preload (502) still carries the payment, marked Failed
  async start(_, form) {
    try {
      return (await ApiService.post(url(), form)).data;
    } catch (error) {
      const data = body(error);
      if (data?.payment) return data;
      throw new Error(data?.detail || data?.title || "start failed");
    }
  },
  async complete(_, id) {
    return (await ApiService.post(url(`/${id}/complete`), {})).data;
  },
  async cancel(_, id) {
    return (await ApiService.post(url(`/${id}/cancel`), {})).data;
  },
  async loadPayments({ commit }) {
    const payments = (await ApiService.get(url())).data || [];
    commit("setPayments", payments);
    return payments;
  },
};

const mutations = {
  setPayments(state, payments) {
    state.payments = payments;
  },
};

export const cardPayments = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
